import { render } from "./AdminPortalView.vue?vue&type=template&id=1c99b044&scoped=true"
import script from "./AdminPortalView.vue?vue&type=script&lang=js"
export * from "./AdminPortalView.vue?vue&type=script&lang=js"

import "./AdminPortalView.vue?vue&type=style&index=0&id=1c99b044&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c99b044"]])

export default __exports__